import React, {
  FC,
  useMemo,
}                         from 'react';
import styled             from 'styled-components';
import CircularProgress   from '@material-ui/core/CircularProgress';
import { IUsageAuctions } from '@typings/auction';
import { Button }         from '@components/Button/Button';
import { ModalDialog }    from '@components/ModalDialog/ModalDialog';

const Li = styled.li`
  display: flex;

  & :nth-child(1) {
    min-width: 200px;
  }
`;

const LoaderWrapper = styled.div`
  display         : flex;
  justify-content : center;
`;

const Separator = styled.span`
  width: 25px;
`;

interface IProps {
  open                : boolean;
  isLoading           : boolean;
  usageAuctions       : IUsageAuctions[];
  onViewAuctionsClick : () => void;
  onClose             : () => void;
}

export const NadaUsageModal: FC<IProps> = ({
  open,
  isLoading,
  usageAuctions = [],
  onViewAuctionsClick,
  onClose,
}) => {
  const content = useMemo<JSX.Element>(
    () => (
      <>
        {isLoading ? (
          <LoaderWrapper>
            <CircularProgress disableShrink />
          </LoaderWrapper>
        ) : (
          <ul>
            {usageAuctions.map((item: IUsageAuctions): JSX.Element => (
              <Li key={item.vin}>
                <span>
                  <span>{item.year}</span>&nbsp;
                  <span>{item.carBrandName}</span>&nbsp;
                  <span>{item.carModelName}</span>
                </span>

                <Separator> - </Separator>

                <span>
                  <span>{item.vin}</span>
                </span>
              </Li>
            ))}
          </ul>
        )}
      </>
    ),
    [isLoading, usageAuctions],
  );

  const actions = useMemo<JSX.Element>(
    () => (
      <Button
        label   = "View Auctions"
        variant = "contained"
        width   = "200px"
        size    = "large"
        onClick = {onViewAuctionsClick}
      />
    ),
    [onViewAuctionsClick],
  );

  return (
    <ModalDialog
      title          = "J.D. Power Book-Out Value Usage"
      titleWeight    = {400}
      open           = {open}
      content        = {content}
      onClose        = {onClose}
      fontSize       = "18px"
      textAlign      = "left"
      textColor      = "black"
      justifyContent = "flex-start"
      width          = "auto"
      actions        = {actions}
    />
  );
};
